var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mr-2",attrs:{"color":"green darken-2"},on:{"click":_vm.generate}},[_vm._v(" mdi-printer-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }